import { LinkProps } from 'next/link';
import { Button } from '../../../../../components/design-system';
import { Link } from '@/i18n/routing';
import Image from 'next/image';

type CtaLink = LinkProps & {
  label: string;
};

interface CtaButton { label: string; onClick: () => void; }

interface Props {
  imageUrl: string;
  title: string;
  body: string;
  cta?: CtaLink | CtaButton;
}

function isLink(object: any): object is CtaLink {
  return 'href' in object;
}

function isButton(object: any): object is CtaButton {
  return !('href' in object);
}

export default function EmptyState(props: Props) {
  return (
    <div className="flex flex-col gap-2 items-center justify-center min-h-[500px]">
      <div className="relative min-w-48 h-48">
        <Image fill className="object-contain" src={props.imageUrl} alt={props.title} />
      </div>
      <h6 className="text-center text-3xl font-bold tracking-tight text-greyscale-body">
        {props.title}
      </h6>
      <p className="max-w-xl text-center text-base font-medium tracking-tight text-greyscale-label">
        {props.body}
      </p>
      {!!props.cta && isLink(props.cta) && (
        <Link
          // @ts-expect-error
          href={props.cta.href}>
          <Button type="link" size="lg">
            {props.cta.label}
          </Button>
        </Link>
      )}
      {!!props.cta && isButton(props.cta) && (
        <Button type="link" size="lg" onClick={props.cta.onClick}>
          {props.cta.label}
        </Button>
      )}
    </div>
  );
}
